import React, { useRef, useState } from 'react'; // 导入useState
import './HomePage.css'; // 引入新的CSS文件

const PricePage = () => {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true); // 初始状态为静音

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(!isMuted); // 切换图标状态
    }
  };

  return (
    <main className="snap-container">
      <section className="snap-section flex items-center">
        <div className="w-9/12 ml-8 mr-2 video-container relative">
          <video
            ref={videoRef} // 使用 ref 来引用视频元素
            src="/media/部署方案视频.mp4"
            autoPlay
            loop
            muted={isMuted} // 根据状态设置静音
            disablePictureInPicture
            playsInline
            className="w-full h-full object-cover rounded-2xl"
          />
          <button
            className="absolute top-5 left-5 bg-white text-black px-2 py-1 rounded-full"
            onClick={toggleMute} // 使用 toggleMute 函数来切换静音状态
          >
            {isMuted ? '🔇' : '🔊'}
          </button>
        </div>

        <div className={`w-3/12 text-white mr-8 ml-2`}>
          <h2 className="text-3xl font-bold my-5">多种部署方式可供选择</h2>
          <p>您能够将 Check-look 几乎可以部署在任意环境中，无论是移动端、微信、小程序、公众号、还是本地的大屏幕，抑或是集成在自有业务的系统中，我们都将是您不二的选择。</p>
        </div>
      </section>

      <section className="snap-section">
        <div className="flex flex-col items-center justify-center h-screen text-white" style={{ textAlign: 'center' }}>
          <h1 className="text-3xl font-bold m-8">准备好踏上您的数字化转型之旅了吗？<br></br>借助Check-look，吸引您的受众并超越传统沟通的界限。<br></br>为您的企业赋能，与专注于您成功的合作伙伴共同前行。</h1>
          <div className="w-full max-w-5xl">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* VIP方案 */}
              <div className="bg-gradient-to-br from-blue-600 to-blue-800 rounded-xl shadow-xl p-6 hover:shadow-2xl transition-all duration-300">
                <h3 className="text-2xl font-bold mb-4">VIP</h3>
                <ul className="text-left space-y-3 mb-6">
                  <li className="flex items-center"><span className="text-green-300 mr-2">✓</span> 每日100次对话</li>
                  <li className="flex items-center"><span className="text-green-300 mr-2">✓</span> 超出部分0.1元每次</li>
                  <li className="flex items-center"><span className="text-green-300 mr-2">✓</span> 支持1个人物定制</li>
                  <li className="flex items-center"><span className="text-green-300 mr-2">✓</span> 默认支持高并发</li>
                </ul>
                <div className="mb-4">
                  <span className="text-2xl font-bold">¥98</span>
                  <span className="text-sm text-gray-300">/月</span>
                </div>
                <div className="mb-6">
                  <span className="text-2xl font-bold">¥680</span>
                  <span className="text-sm text-gray-300">/年</span>
                </div>
                <button className="w-full bg-white text-blue-800 font-bold py-2 px-4 rounded-lg hover:bg-blue-100 transition-colors duration-300">
                  选择VIP
                </button>
              </div>

              {/* SVIP方案 */}
              <div className="bg-gradient-to-br from-purple-600 to-purple-800 rounded-xl shadow-xl p-6 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                <div className="absolute top-0 right-0 bg-yellow-400 text-purple-900 font-bold px-3 py-1 rounded-bl-lg rounded-tr-xl">
                  推荐
                </div>
                <h3 className="text-2xl font-bold mb-4">SVIP</h3>
                <ul className="text-left space-y-3 mb-6">
                  <li className="flex items-center"><span className="text-green-300 mr-2">✓</span> 每日500次对话</li>
                  <li className="flex items-center"><span className="text-green-300 mr-2">✓</span> 超出部分0.1元每次</li>
                  <li className="flex items-center"><span className="text-green-300 mr-2">✓</span> 支持3个人物定制</li>
                  <li className="flex items-center"><span className="text-green-300 mr-2">✓</span> 默认支持高并发</li>
                </ul>
                <div className="mb-4">
                  <span className="text-2xl font-bold">¥298</span>
                  <span className="text-sm text-gray-300">/月</span>
                </div>
                <div className="mb-6">
                  <span className="text-2xl font-bold">¥2680</span>
                  <span className="text-sm text-gray-300">/年</span>
                </div>
                <button className="w-full bg-white text-purple-800 font-bold py-2 px-4 rounded-lg hover:bg-purple-100 transition-colors duration-300">
                  选择SVIP
                </button>
              </div>

              {/* 企业定制 */}
              <div className="bg-gradient-to-br from-gray-700 to-gray-900 rounded-xl shadow-xl p-6 hover:shadow-2xl transition-all duration-300">
                <h3 className="text-2xl font-bold mb-4">企业定制</h3>
                <ul className="text-left space-y-3 mb-6">
                  <li className="flex items-center"><span className="text-green-300 mr-2">✓</span> 定制化服务</li>
                  <li className="flex items-center"><span className="text-green-300 mr-2">✓</span> 专属技术支持</li>
                  <li className="flex items-center"><span className="text-green-300 mr-2">✓</span> 更多功能</li>
                  <li className="flex items-center"><span className="text-green-300 mr-2">✓</span> 默认支持高并发</li>
                </ul>
                <div className="mb-6">
                  <p className="text-gray-300 mb-4">联系我们获取定制方案</p>
                  <a href="mailto:406117951@qq.com" className="text-blue-300 hover:text-blue-100 underline">
                    406117951@qq.com
                  </a>
                </div>
                <button className="w-full bg-white text-gray-800 font-bold py-2 px-4 rounded-lg hover:bg-gray-100 transition-colors duration-300">
                  联系我们
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default PricePage;